import React, { Component } from 'react';
import * as Progress from 'react-native-progress';
import { DateUtils, StringUtils } from '../utils';
import { StyleSheet, View, TouchableOpacity, Platform, ScrollView, FlatList, Image } from 'react-native';
import { Cards, Icon, Colors, Routes, Text } from '../components';
import { Video } from 'expo-av';
import { useNavigate } from 'react-router-dom';

class MyAccountCards_Base extends Component {

  constructor(props) {
    super(props);
    this.state = {
      current_card_index: 0
    }

    this.theCards = React.createRef();

    this.swipeNext = this.swipeNext.bind(this);
  }

  goBack = () => {
    if(Platform.OS === 'web') {
      this.props.navigate(-1);
    } else {
      this.props.navigation.goBack();
    }
  }

  swipeNext() {
    let current_card_index = ++this.state.current_card_index;

    if(current_card_index >= 3) current_card_index = 0;

    this.theCards.theList.scrollToIndex({index: current_card_index});

    this.setState({current_card_index})
  }

  render_next_swipe_button = () => {
    return <TouchableOpacity onPress={this.swipeNext} style={{flexDirection: 'row', height: 120, width: 20, paddingHorizontal: 5, alignItems: 'center'}}>
    <Icon name='chevron-right' size={18} solid={true} color={'#cccccc'} />
  </TouchableOpacity>
  }

  render_my_pets_card = () => {
    let display_add_pet = this.props.display_add_pet;
    let title_text      = display_add_pet ? 'Add your first pet!' : 'My Pets';

    return <TouchableOpacity style={{ flexDirection: 'row', backgroundColor: 'white', height: 120, borderRadius: 12, padding: 20, alignItems: 'center', flex: 1 }}
                             onPress={ () => {
                               this.props.navigate(Routes.PET_LIST)
                             }}>

      { !display_add_pet ? <Image style={{ height: 80, width: 80 }} source={ require('../assets/images/pets-allowed.png') } /> : null }
      {  display_add_pet ? <Image style={{ height: 50, width: 50 }} source={ require('../assets/images/add-new.png') } />      : null }

      <View style={{ flex: 1, height: '100%', paddingLeft: 20, justifyContent: 'center' }}>
        <Text style={{ fontSize: 20, fontWeight: '500', color: '#040415' }}>{ title_text }</Text>
        { display_add_pet ? null : <Text style={{ color: Colors.PRIMARY, marginTop: 5, fontSize: 16 }}>Add | Edit | Details</Text> }
      </View>
      {this.render_next_swipe_button()}
     </TouchableOpacity>
  }

  render() {
    return <View>
      <View style={{ }}>
        <Cards ref={node => this.theCards = node} current_card_index={this.state.current_card_index}  data={ [ this.render_my_pets_card(),
                         <TouchableOpacity style={{ flexDirection: 'row', backgroundColor: 'white', height: 120, borderRadius: 12, padding: 20, alignItems: 'center', flex: 1 }}
                                           onPress={ () => {
                                             this.props.navigate(Routes.SETTINGS)
                                           }}>
                           <Image style={{ height: 80, width: 80 }} source={ require('../assets/images/user-settings.png') } />
                           <View style={{ flex: 1, height: '100%', paddingLeft: 20, justifyContent: 'center' }}>
                             <Text style={{ fontSize: 20, fontWeight: '500', color: '#040415' }}>Settings</Text>
                             <Text style={{ color: Colors.PRIMARY, marginTop: 5, fontSize: 16 }}>Profile | Settings</Text>
                           </View>
                           {this.render_next_swipe_button()}
                          </TouchableOpacity>,
                          <TouchableOpacity style={{ flexDirection: 'row', backgroundColor: 'white', height: 120, borderRadius: 12, padding: 20, alignItems: 'center', flex: 1 }}
                                            onPress={ () => {
                                              this.props.navigate(Routes.CONSULTATIONS_COMPLETED)
                                            }}>
                            <Image style={{ height: 60, width: 60, marginLeft: 10 }} source={ require('../assets/images/completed-consultations.png') } />
                            <View style={{ flex: 1, height: '100%', paddingLeft: 20, justifyContent: 'center' }}>
                              <Text style={{ fontSize: 20, fontWeight: '500', color: '#040415' }}>Completed Consultations</Text>
                            </View>
                            {this.render_next_swipe_button()}
                           </TouchableOpacity> ] }
                dots={true}
              />
      </View>
    </View>
  }


}

function MyAccountCards(props) {
  if(Platform.OS === 'web') {
    const navigate = useNavigate();
    return  <MyAccountCards_Base {...props} navigate={navigate} />
  } else {
    return  <MyAccountCards_Base {...props} navigate={props.navigation.push}  />
  }
}

const styles = StyleSheet.create({

});

export default MyAccountCards
